import SchnupfspruchGenerator from './schnupfspruch-generator';

function App() {
    return <SchnupfspruchGenerator />;
}

export default App;